import React, { useState } from 'react';
import RegionSelect from '@/pages/home/components/RegionSelect';
import NewRegionSelect from '@/pages/home/components/NewRegionSelect';

export default (props: any) => {
  const [regionMarketSelectArr, setRegionMarketSelectArr] = useState(['bj'])

  const [value, setValue] = useState({
    type: 'market',
    regions: [],
    markets: ['255']
  });
  const regionCountry = [
    {
      country: [
        { country_name_abbre: 'ao', country_name_cn: '安哥拉', country_name_en: 'Angola' },
        { country_name_abbre: 'bj', country_name_cn: '贝宁', country_name_en: 'Benin' }

      ],
      region_abbre: 'af',
      region_key: 'AF',
      region_name_cn: '非洲',
      region_name_en: 'Africa'
    },
    {
      country: [
        { country_name_abbre: 'hk', country_name_cn: '中国香港', country_name_en: '中国香港', icon: 'https://ogdb-cdn.intlgame.cn/front/pc/dashboard/dashboard/static/cn.76419d2a.svg' },
        { country_name_abbre: 'mo', country_name_cn: '中国澳门', country_name_en: 'Macau', icon: 'https://ogdb-cdn.intlgame.cn/front/pc/dashboard/dashboard/static/cn.76419d2a.svg' },
        { country_name_abbre: 'tw', country_name_cn: '中国台湾', country_name_en: 'Taiwan', icon: 'https://ogdb-cdn.intlgame.cn/front/pc/dashboard/dashboard/static/cn.76419d2a.svg' }

      ],
      region_abbre: 'hmt',
      region_key: 'HMT',
      region_name_cn: '港澳台',
      region_name_en: 'China(HK,MO,TW)'
    },
  ]

  const formatOptions = regionCountry.map((item: any) => {
    const { country = [], region_abbre: regionValue, region_name_cn: textCN, region_name_en: text } = item;
    const children = country?.map((subItem: any) => {
      const { country_name_abbre: countryValue, country_name_cn: textCN, country_name_en: text } = subItem;
      return {
        ...subItem,
        value: countryValue,
        text,
        textCN,
      }
    }) || [];
    return {
      ...item,
      value: regionValue,
      text,
      textCN,
      children
    }
  });

  const radioOptions = [
    {
      value: '255',
      text: 'All',
      textCN: '全部'
    },
    {
      value: '0',
      text: 'qita',
      textCN: '其他'
    }
  ];

  return (
    <>
      <div style={{ height: 500 }}>
        <RegionSelect
          locale="zh-CN"
          localeTexts={{
            "zh-CN": { clear_all: "全清" },
          }}
          popularList={['ao', 'mo']}
          regionType={"market"}
          hiddenNoChina={true}
          showChinese={false}
          regionCountry={regionCountry}
          defaultValue={[]}
          value={regionMarketSelectArr}
          onChange={tags => {
            // console.log('tags:', tags)
          }}
        />
      </div>
      <div style={{ height: 500 }}>
        <NewRegionSelect
        className="search-item"
        value={value}
        options={formatOptions}
        popularList={['ao', 'mo']}
        onCloseReginSelect={(value)=>{console.log(value)}}
        radioOptions={radioOptions} />
      </div>
    </>

  );
};
